/* src/app/pages/home/home.component.css */
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/home.component.css.map */
